import { render, staticRenderFns } from "./PlayerModal.vue?vue&type=template&id=a4da2a2c&scoped=true&"
import script from "./PlayerModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PlayerModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PlayerModal.vue?vue&type=style&index=0&id=a4da2a2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4da2a2c",
  null
  
)

export default component.exports